import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BorderIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="M75 112.5V225h75v-75h75V75H112.5a37.49 37.49 0 0 0-26.516 10.984A37.485 37.485 0 0 0 75 112.5zM1087.5 75H975v75h75v75h75V112.5a37.49 37.49 0 0 0-10.984-26.516A37.485 37.485 0 0 0 1087.5 75zM300 75h150v75H300zM75 300h75v150H75zM150 525H75v150h75v-37.5h75v-75h-75zM75 750h75v150H75zM1050 300h75v150h-75zM1050 562.5h-75v75h75V675h75V525h-75zM1050 750h75v150h-75zM750 75h150v75H750zM1050 1050h-75v75h112.5a37.49 37.49 0 0 0 26.516-10.984A37.485 37.485 0 0 0 1125 1087.5V975h-75zM150 975H75v112.5a37.49 37.49 0 0 0 10.984 26.516A37.485 37.485 0 0 0 112.5 1125H225v-75h-75zM750 1050h150v75H750zM300 1050h150v75H300zM525 75v75h37.5v75h75v-75H675V75zM562.5 300h75v150h-75zM637.5 525h-75v37.5H525v75h37.5V675h75v-37.5H675v-75h-37.5zM562.5 750h75v150h-75zM637.5 975h-75v75H525v75h150v-75h-37.5zM750 562.5h150v75H750zM300 562.5h150v75H300z" />
    </g>
  </svg>
);

BorderIcon.propTypes = propTypes;

export default BorderIcon;
